import { Moment } from 'moment'
import { gql } from '@apollo/client/core'
import { MailType } from 'globals/models/Mail'

export const USER_MAIL_FRAGMENT = gql`
  fragment MailDetailsUserMailFragment on UserMail {
    id,
    createdAt,
    dateOfReceipt,
    forwardedAt,
    mailType,
    physicalLocation,
    physicallyDestroyedAt,
    processingDate,
    processingType,
    provisionedAt,
    queryDate,
    scanFile,
    scannedAt,
    sendName,
    thumbScanFile,
    weight,
    trackingNumber
  }
`

export interface UserMailVariables {
  id: number
  createdAt: string
  dateOfReceipt: string
  forwardedAt: string
  mailType: string,
  physicalLocation: string,
  physicallyDestroyedAt: string,
  processingDate: string,
  processingType: string,
  provisionedAt: string,
  queryDate: string,
  scanFile: string,
  scannedAt: string,
  sendName: string,
  weight: number,
  trackingNumber: string
}
export interface MailActionVariables {
  userMailId: number,
  trackingNumber?: string
}

export const MARK_NPAI = gql`
  mutation userMailMarkNpai($userMailId: ID!) {
    userMailMarkNpai(userMailId: $userMailId) {
      userMail {
        ...MailDetailsUserMailFragment
      }
    }
  }
  ${USER_MAIL_FRAGMENT}
`

export interface MarkNpaiResult {
  userMailMarkNpai: {
    userMail: UserMailVariables
  }
}

export const PHYSICALLY_DESTROY_MAIL = gql`
  mutation userMailPhysicallyDestroy($userMailId: ID!) {
    userMailPhysicallyDestroy(userMailId: $userMailId) {
      userMail {
        ...MailDetailsUserMailFragment
      }
    }
  }
  ${USER_MAIL_FRAGMENT}
`

export interface PhysicallyDestroyMailResult {
  userMailPhysicallyDestroy: {
    userMail: UserMailVariables
  }
}

export const DELETE_MAIL_LINE = gql`
  mutation userMailDestroy($userMailId: ID!) {
    userMailDestroy(userMailId: $userMailId) {
      userMail {
        ...MailDetailsUserMailFragment
      }
    }
  }
  ${USER_MAIL_FRAGMENT}
`

export interface DeleteMailLineResult {
  userMailDestroy: {
    userMail: UserMailVariables
  }
}

export const UPDATE_MAIL = gql`
  mutation userMailUpdate(
  $userMailId: ID!,
  $mailType: UserMailTypes,
  $weight: Int,
  $sendName: String,
  $dateOfReceipt: ISO8601DateTime,
  $scanFile: Upload,
  $trackingNumber: String
) {
  userMailUpdate(
    userMailId: $userMailId,
    mailType: $mailType,
    weight: $weight,
    sendName: $sendName,
    dateOfReceipt: $dateOfReceipt,
    scanFile: $scanFile,
    trackingNumber: $trackingNumber
  ) {
    userMail {
      ...MailDetailsUserMailFragment
    }

  }
}
${USER_MAIL_FRAGMENT}
`

export const UPDATE_TRACKING_NUMBER = gql`
mutation userMailUpdate(
  $userMailId: ID!,
  $trackingNumber: String
  ) {
    userMailUpdate(
    userMailId: $userMailId,
    trackingNumber: $trackingNumber
    ) {
      userMail {
        ...MailDetailsUserMailFragment
      }
    }
  }
  ${USER_MAIL_FRAGMENT}
`


export interface UpdateMailResult {
  userMailUpdate: {
    userMail: UserMailVariables
  }
}
export interface UpdateMailVariables {
  userMailId: number | undefined,
  mailType: MailType | undefined,
  weight?: number,
  sendName?: string,
  dateOfReceipt?: string | Moment,
  scanFile?: File,
  trackingNumber?: string
}
